import * as Y from 'yjs';
import { v4 as uuidv4 } from 'uuid';

export default function addComment(blocks: Y.Array<any>, blockId: string, text: string, userId?: string) {
    let foundBlock = null;

    for (const block of blocks.toArray()) {
        if (block.toJSON().type === 'callout') {
            if (block.get('id') === blockId) {
                foundBlock = block;
                break;
            }
            const childBlock = block
                .get('children')
                .toArray()
                .find((child: any) => child.get('id') === blockId);

            if (childBlock) {
                foundBlock = childBlock;
                break;
            }
        } else if (block.get('id') === blockId) {
            foundBlock = block;
            break;
        }
    }

    if (foundBlock) {
        foundBlock.set('comments', [
            ...(foundBlock.get('comments') ?? []),
            {
                id: uuidv4(),
                blockId: blockId,
                userId: userId ?? '',
                text: text.trim(),
                createdAt: new Date().toISOString(),
            },
        ]);
    }
}
